import { route as boardsRoute } from "@faire/web-api--source/routes/www/boards";
import { route as followingBoardsRoute } from "@faire/web-api--source/routes/www/boards/following";
import { route as brandRoute } from "@faire/web-api--source/routes/www/brand/brandToken";
import { route as c1Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import { route as c2Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId";
import { route as c3Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId";
import { route as ordersRoute } from "@faire/web-api--source/routes/www/orders";
import { route as collectionRoute } from "@faire/web-api--source/routes/www/product-based-collection/product_based_collection_token";
import { route as productRoute } from "@faire/web-api--source/routes/www/product/productToken";
import { route as homeRoute } from "@faire/web-api--source/routes/www/root";
import { route as searchRoute } from "@faire/web-api--source/routes/www/search";
import { RetailerRoute } from "@faire/web/common/routes/RetailerRouteMatcher";

export const MOBILE_APP_PROMOTION_ALLOWED_PATHS: RetailerRoute[] = [
  searchRoute,
  brandRoute,
  productRoute,
  ordersRoute,
  c1Route,
  c2Route,
  c3Route,
  boardsRoute,
  followingBoardsRoute,
  homeRoute,
  collectionRoute,
];

export const MOBILE_APP_PROMOTION_BLOCKED_PATHS = [
  "/retailer/:retailerToken/category/International%20Best%20Sellers",
  "/category/International%20Best%20Sellers",
  "/confirm-identity/*",
];

export const PROMO_MODAL_LAST_TIME_SEEN_STORAGE_KEY =
  "PROMO_MODAL_LAST_TIME_SEEN";
